import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from '../firebase';

/**
 * Upload a document (PDF/DOCX) to Firebase Storage
 * @param {File} file - The document file to upload
 * @param {string} schoolId - School ID for storage path
 * @param {string} entityType - Type of entity (e.g., 'consequenceTypes')
 * @param {string} entityId - Entity ID for storage path
 * @returns {Promise<{fileName, fileUrl, fileType, storagePath}>}
 */
export const uploadDocument = async (file, schoolId, entityType, entityId) => {
  if (!file || !schoolId || !entityType || !entityId) {
    throw new Error('Missing required parameters for document upload');
  }

  const timestamp = Date.now();
  const safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
  const storagePath = `schools/${schoolId}/documents/${entityType}/${entityId}/${timestamp}_${safeName}`;
  const storageRef = ref(storage, storagePath);

  const snapshot = await uploadBytes(storageRef, file);
  const fileUrl = await getDownloadURL(snapshot.ref);

  return {
    fileName: file.name,
    fileUrl,
    fileType: file.type,
    storagePath
  };
};

/**
 * Delete a document from Firebase Storage
 * @param {string} storagePath - Full storage path of the document
 */
export const deleteDocument = async (storagePath) => {
  if (!storagePath) throw new Error('Missing storage path');
  const storageRef = ref(storage, storagePath);
  await deleteObject(storageRef);
};
